import store from '@Store';
import { stateCurrentName as stateCurrentNameSelector } from '@Selectors/StateCurrentSelectors';

function addSourceKey(request) {
  // RXFE-3377
  if (!request.ignoreAllSpecificHeaders) {
    const sourceKey = stateCurrentNameSelector(store.getState());
    request.headers = {
      sourceKey,
      ...request.headers,
    };
  }
  return request;
}

const SourceKeyInterceptor = {
  request: (config) => addSourceKey(config),
};

export default SourceKeyInterceptor;
